/**
 * This file has same contents as apps/webserver/src/config/env/analysisTypes.constants.js
 * This file is intended for all backend services (webserver and microservices) to use, while
 * apps/webserver/src/config/env/analysisTypes.constants.js is intended for the client
 * Test in apps/webserver/src/config/env/analysisTypes.constants.spec.js verifies the contents
 * of the two files are identical
 *
 * duplicated by
 * {@link libs/sql/src/lib/account/getAccountAnalysisUsageByAnalysisType.ts}
 */
export enum ListAnalysisIds {
  FCD = 'FCD',
  AFI = 'AFI',
  ALERTS = 'ALERTS',
  ALERTS_BATCH = 'ALERTS-BATCH',
  GHG = 'GHG',
}

export const analysisTypes = {
  FOREST_CHANGE_DIAGNOSTICS: 'FCD',
  DEFORESTATION_KPIS: 'AFI',
  ALERTS: 'ALERTS',
  GREENHOUSE_GAS_EMISSIONS: 'GHG',
  PALM_RISK: 'PalmRisk',
};

export const analysisTypesOptionsNewNames = [
  {
    id: analysisTypes.DEFORESTATION_KPIS,
    label: 'Post-2020 Risk Assessment',
    shortLabel: 'Post-2020',
    description: 'Deforestation in natural forest since 2021 + additional contextual datasets',
    showInUI: true,
  },
  {
    id: analysisTypes.ALERTS,
    label: 'Recent Disturbance Alerts',
    shortLabel: 'Alerts',
    description: 'Recent global integrated disturbance alerts for one time analysis.',
    showInUI: true,
  },
  {
    id: analysisTypes.FOREST_CHANGE_DIAGNOSTICS,
    label: 'Post-2000 Forest Change',
    shortLabel: 'Post-2000',
    description: 'Annual tree cover loss since 2001 + additional contextual and regional datasets',
    showInUI: true,
  },
  {
    id: analysisTypes.GREENHOUSE_GAS_EMISSIONS,
    label: 'Greenhouse Gas Emissions',
    shortLabel: 'GHG',
    description: 'Greenhouse gas emissions from deforestation and forest degradation',
    showInUI: false,
  },
];

export enum AlertsAnalysisFrequency {
  WEEKLY = 'Weekly',
}

export const analysisIdsOptionsMap = {
  [analysisTypes.FOREST_CHANGE_DIAGNOSTICS]: [analysisTypes.PALM_RISK],
  [analysisTypes.ALERTS]: [AlertsAnalysisFrequency.WEEKLY],
};
